import { FC } from 'react'
import styled from 'styled-components'
import { media } from '../../theme/breakpoints'

const switchWidth = 52
const switchHeight = 28
const switchPadding = 4

const sliderHeight = switchHeight - 2 * switchPadding
const sliderWidth = sliderHeight
const slideDistance = switchWidth - 2 * switchPadding - sliderWidth

const Container = styled.div`
    display: flex;
    flex-direction: column;
`

const Label = styled.label`
    font-size: 13px;
    color: ${(p) => p.theme.colors.mediumGrey};
    margin-bottom: 4px;
    height: 16px;
`

const Switch = styled.label`
    position: relative;
    display: inline-block;
    width: ${switchWidth}px;
    height: ${switchHeight}px;
    box-sizing: border-box;

    ${media.tabletAndBelow} {
        min-height: 44px;
        min-width: 44px;
    }
`

const Input = styled.input`
    opacity: 0;
    width: 0;
    height: 0;
`

const Slider = styled.span<{ $checked: boolean }>`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: 0.4s;
    -o-transition: all 0.4s;
    -moz-transition: all 0.4s;
    -webkit-transition: all 0.4s;
    background-color: ${(p) =>
        p.$checked ? p.theme.colors.primaryGreen : p.theme.colors.lightGrey};

    border-radius: ${switchHeight}px;
    box-sizing: border-box;

    &::before {
        position: absolute;
        content: '';
        width: ${sliderWidth}px;
        height: ${sliderHeight}px;
        border-radius: 50%;
        left: 4px;
        bottom: ${switchPadding}px;
        background-color: white;

        transition: 0.4s;
        -o-transition: all 0.4s;
        -moz-transition: all 0.4s;
        -webkit-transition: all 0.4s;

        transform: ${(p) =>
            p.$checked ? `translateX(${slideDistance}px)` : 'none'};
    }
`

interface Props {
    label?: string
    checked: boolean
    onSwitch: (on: boolean) => void
}

export const ToggleSwitch: FC<Props> = ({ label, checked, onSwitch }) => {
    return (
        <Container>
            {label && <Label>{label}</Label>}

            <Switch>
                <Input
                    type="checkbox"
                    defaultChecked={checked}
                    onClick={() => {
                        onSwitch(!checked)
                    }}
                />
                <Slider $checked={checked} />
            </Switch>
        </Container>
    )
}
